import { RouteGuard } from "@/router/routeGuard";
import { RouteConfig } from "vue-router";

const routes: Array<RouteConfig> = [
  {
    path: "/cadastros/saude/prestadores/lista",
    name: "ListagemPrestadores",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/prestador/ListagemPrestadores.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/saude/prestadores/cadastro/:idPrestador?",
    name: "CadastroPrestadoresSaude",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/prestador/CadastroPrestador.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/servicos-saude/especialidades",
    name: "ListaEspecialidades",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/especialidades/ListaEspecialidades.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/servicos-saude/especialidade/cadastro/:idEspecialidade?",
    name: "CadastroEspecialidade",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/especialidades/CadastroEspecialidade.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/servicos-saude/cidades",
    name: "ListaCidades",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/cidade/ListaCidades.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/servicos-saude/cidade/cadastro/:idCidade?",
    name: "CadastroCidade",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/cidade/CadastroCidade.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/servicos-saude/cadastro/parametro",
    name: "CadastroParametro",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/parametrizacao/CadastroParametro.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/servicos-saude/agenda/prestador/filtro",
    name: "ListagemConfiguracaoAgendaPrestador",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/agenda/prestador/ListaConfiguracaoAgendaPrestador.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path:
      "/cadastros/servicos-saude/agenda/prestador/cadastro/:idConfiguracao?",
    name: "CadastroConfiguracaoAgendaPrestador",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/agenda/prestador/CadastroAgendaPrestador.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  {
    path: "/cadastros/servicos-saude/agenda/profissional/filtro",
    name: "ListagemConfiguracaoAgendaProfissional",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/agenda/profissional/ListaConfiguracaoAgendaProfissional.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path:
      "/cadastros/servicos-saude/agenda/profissional/cadastro/:idConfiguracao?",
    name: "CadastroConfiguracaoAgendaProfissional",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/agenda/profissional/CadastroConfiguracaoAgendaProfissional.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },
  {
    path: "/cadastros/servicos-saude/agenda/visualizar",
    name: "VisualizacaoAgenda",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/agenda/visualizar/VisualizarAgenda.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },  
  {
    path: "/cadastros/servicos-saude/feriados",
    name: "ListaFeriados",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/feriado/ListaFeriados.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  {
    path: "/cadastros/servicos-saude/feriado/cadastro/:idFeriado?",
    name: "CadastroFeriado",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/feriado/CadastroFeriado.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  {
    path: "/cadastros/servicos-saude/precificacoes",
    name: "ListaPrecificacoesSaude",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/precificacao-associado/ListaPrecificacoes.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  {
    path: "/cadastros/servicos-saude/precificacao/cadastro/:idPrecificacao?",
    name: "CadastroPrecificacaoSaude",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/precificacao-associado/CadastroPrecificacao.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  {
    path: "/cadastros/servicos-saude/lista-atendimentos",
    name: "ListaAtendimentos",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/atendimento/ListaAtendimentos.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  {
    path: "/cadastros/servicos-saude/lista-atendimentos/detalhe-atendimento/:idAtendimento?",
    name: "DetalheAtendimento",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/atendimento/DetalheAtendimento.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  {
    path: "/cadastros/servicos-saude/lista-atendimentos/detalhe-atendimento/incluir-orcamento/:idAtendimento",
    name: "IncluirOrcamento",
    component: () =>
      import(
        /* webpackChunkName: "cadastros-saude" */ "@/views/private/cadastros/saude/atendimento/Orcamento.vue"
      ),
    beforeEnter: RouteGuard.acessoSaude
  },

  
];

export default routes;
